const mutations = {
  SET_TEACHERS: (state, teachers) => {
    state.teachers = teachers;
  },

  SET_COLUMNS: (state, columns) => {
    state.columns = columns;
  },

  SET_CURRENT_PAGE: (state, currentPage) => {
    state.currentPage = currentPage;
  },

  SET_PAGE_SIZE: (state, pageSize) => {
    state.pageSize = pageSize;
  },

  SET_TOTAL_COUNT: (state, count) => {
    state.count = count;
  },

  SET_REFRESH_DATE: (state, timestamp) => {
    state.lastRefreshDate = timestamp;
  },

  SET_ORDERING: (state, ordering) => {
    state.ordering = ordering;
  },

  SET_ORG: (state, org) => {
    state.filterByOrg = org;
  },

  SET_LANGUAGE: (state, language) => {
    state.filterByLanguage = language;
  },

  SET_SEARCH_KEYWORD: (state, keywords) => {
    state.searchKeywords = keywords;
  },

  SET_AVAILABILITY: (state, value) => {
    state.availabilityFilter.no_availability.value = value;
  },

  SET_AVAILABILITY_3_WEEK: (state, value) => {
    state.availabilityFilter.no_availability_3week.value = value;
  },

  SET_ACTIVE: (state, value) => {
    state.active = value;
  },

  SET_TEACHER_PROFILE: (state, teacherProfile) => {
    state.teacherProfile = teacherProfile;
  },

  UPDATE_TEACHER_PROFILE: (state, updates) => {
    if (!state.teacherProfile) {
      return;
    }

    state.teacherProfile = {
      ...state.teacherProfile,
      ...updates,
    };
  },
};

export default mutations;
